import { useState, useEffect, useCallback } from 'react';

export function useSharedFilterToggle(defaultHidden = false) {
  const [hidden, setHidden] = useState(() => {
    const saved = sessionStorage.getItem('filtersHidden');
    if (saved !== null) return saved === 'true';
    return defaultHidden;
  });

  // Listen for any toggle from anywhere
  useEffect(() => {
    const handler = (e) => setHidden(e.detail);
    window.addEventListener('filtersVisibilityChange', handler);
    return () => window.removeEventListener('filtersVisibilityChange', handler);
  }, []);

  // Flip, persist, and broadcast
  const toggle = useCallback(() => {
    const next = !hidden;
    sessionStorage.setItem('filtersHidden', String(next));
    window.dispatchEvent(
      new CustomEvent('filtersVisibilityChange', { detail: next })
    );
    setHidden(next);
  }, [hidden]);

  return { hidden, toggle };
}
